interface AsideSectionProps {
  children: React.ReactNode;
}

function AsideSection({ children }: AsideSectionProps): JSX.Element {
  return (
    <div className="border-l-4 border-gray-300 bg-gray-50 p-4">{children}</div>
  );
}

export default AsideSection;
